<script setup lang="ts"></script>

<template>
  <main>
    <div class="container-fluid">
      <slot />
    </div>
  </main>
</template>

<style scoped>
.container-fluid {
  padding: var(--container-padding);
}
</style>
